// extracted by mini-css-extract-plugin
export default {"title":"SettingsPage_title__Pu1Tt","containerDesktop":"SettingsPage_containerDesktop__AhzCA","containerMobile":"SettingsPage_containerMobile__CgdMv"};